import { createApp } from 'vue';

const app = createApp({
    data() {
        return {
            privacyPolicyCheck: false,
            showprivacyError: false,
            showprivacyErrorServer: true
        };
    },
    watch: {
        privacyPolicyCheck: function () {
            if (this.privacyPolicyCheck) {
                this.showprivacyError = false;
                this.showprivacyErrorServer = false;
            }
        }

    },
    created: function () {

    },
    methods: {
        checkSubmit: function() {
            if (!this.privacyPolicyCheck) {
                this.showprivacyError = true;
            }
        }
    }
});

app.mount('#registration-page');